import { useIntl } from 'react-intl';
import {
  editableStyle,
  inputStyleConcrete,
  noEditableStyleConcrete,
} from '../styles';
import { Table } from '../Table';
import { Row } from '../Table/row';
import PropTypes from '../../../utils/propTypes';

const TotalTable = ({ values, formValue, updateForm }) => {
  const intl = useIntl();
  const onChangeInput = (value) => {
    updateForm(value);
  };

  return (
    <Table width="25%">
      <Row
        cells={[
          {
            value: `${intl.formatMessage({ id: 'project' })}: `,
            style: { backgroundColor: '#e6e6e6', width: '50%' },
          },
          {
            html: (
              <div>
                <input
                  min={0}
                  type="number"
                  value={formValue}
                  onChange={({ target: { value } }) => onChangeInput(value)}
                  style={inputStyleConcrete}
                  onBlur={() => {
                    if (!formValue) {
                      updateForm(0);
                    }
                  }}
                ></input>
                <span
                  style={{
                    textTransform: 'none',
                    color: 'black',
                    fontSize: '15px',
                  }}
                >
                  {' m'}
                  <sup>3</sup>
                </span>
              </div>
            ),
            style: editableStyle,
          },
        ]}
      />
      <Row
        cells={[
          {
            value: `${intl.formatMessage({ id: 'work' })}: `,
            style: { backgroundColor: '#e6e6e6' },
          },
          {
            html: (
              <p style={{ textTransform: 'none', color: '#ff0000' }}>
                {`${values.resistant} m`}
                <sup style={{ color: '#ff0000' }}>3</sup>
              </p>
            ),
            style: {
              borderRight: '2px solid #f1f1f1',
              ...noEditableStyleConcrete,
            },
          },
        ]}
      />
      <Row
        cells={[
          {
            value: `${intl.formatMessage({ id: 'deviation' })}: `,
            style: { backgroundColor: '#e6e6e6' },
          },
          {
            html: (
              <p style={{ textTransform: 'none' }}>
                {`${values.resistant - values.projected} m`}
                <sup>3</sup>
              </p>
            ),
            style: {
              borderRight: '2px solid #f1f1f1',
              ...noEditableStyleConcrete,
            },
          },
        ]}
      />
    </Table>
  );
};

TotalTable.propTypes = {
  values: PropTypes.object.isRequired,
  formValue: PropTypes.number.isRequired,
  updateForm: PropTypes.func.isRequired,
};

export default TotalTable;
